import { Navigate } from "react-router-dom";
import { getToken } from "../../../system/encryption";
import { globalConstants } from "../../../constants/index";
import { getUserData } from "../../../system";

const PublicRoute = ({ children }) => {
    const token = getToken();
    const userToken = token || globalConstants.EMPTY_STRING;
    if (userToken && userToken.length > 0) {
      const user = getUserData();
      if (user && user.is_super_admin) {
        return <Navigate to="/platform-dashboard" />;
      }
      return <Navigate to="/dashboard" />;
    } else {
     return children;
    }
};

export default PublicRoute;